import { Link } from "react-router-dom";
import { Phone, MessageCircle, ClipboardList } from "lucide-react";
import { useSettings } from "../lib/hooks";
import { telLink, waLink, track } from "../lib/api";

export default function MobileActionBar() {
  const { data: settings } = useSettings();
  return (
    <div
      data-testid="mobile-action-bar"
      className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-graphite/85 backdrop-blur-xl border-t border-white/10"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-3">
        <a
          href={telLink(settings)}
          onClick={() => track("phone_click", { location: "mobile_bar" })}
          data-testid="mobile-bar-call"
          className="flex flex-col items-center gap-1 py-3 text-white/90 active:text-ember"
          aria-label="Call NOOR"
        >
          <Phone size={18} strokeWidth={1.5} />
          <span className="text-[10px] font-mono tracking-[0.2em] uppercase">Call</span>
        </a>
        <a
          href={waLink(settings)}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => track("whatsapp_click", { location: "mobile_bar" })}
          data-testid="mobile-bar-whatsapp"
          className="flex flex-col items-center gap-1 py-3 text-white/90 active:text-ember border-x border-white/10"
          aria-label="WhatsApp NOOR"
        >
          <MessageCircle size={18} strokeWidth={1.5} />
          <span className="text-[10px] font-mono tracking-[0.2em] uppercase">WhatsApp</span>
        </a>
        <Link
          to="/request-a-consultation"
          data-testid="mobile-bar-consultation"
          className="flex flex-col items-center gap-1 py-3 text-ember"
          aria-label="Request a consultation"
        >
          <ClipboardList size={18} strokeWidth={1.5} />
          <span className="text-[10px] font-mono tracking-[0.2em] uppercase">Consult</span>
        </Link>
      </div>
    </div>
  );
}
